<template>
  <DatatableReportV3
    title="Commissions List"
    :source="source"
    :config="config"
    :filters="filters"
  />
</template>

<script>
import JobCommisssionLink from "@/Job/Commissions/JobCommissionsLink.vue";
import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";
import { customerClassificationColumns } from "@/lib/customerTypes";
import store from "@/vuex/store";

export default {
  components: {
    DatatableReportV3
  },
  props: {
    source: {
      type: String,
      default: ""
    },
    filters: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      config: {
        responsive: true,
        order: [[0, "desc"]],
        columns: [
          {
            data: "completed_on",
            title: "Completed",
            searchable: false,
            responsivePriority: 5
          },
          { data: "job", responsivePriority: 2 },
          ...customerClassificationColumns(),
          { data: "customer", responsivePriority: 1 },
          { data: "customer_email", title: "Email", responsivePriority: 9 },
          { data: "customer_phone", title: "Phone", responsivePriority: 8 },
          {
            data: "location_name",
            title: "Location Name",
            responsivePriority: 10
          },
          { data: "address", orderable: false, responsivePriority: 11 },
          {
            data: "technician",
            filterName: "technician_id",
            responsivePriority: 4
          },
          {
            data: "revenue",
            className: "text-right",
            searchable: false,
            responsivePriority: 6
          },
          {
            data: "commission",
            className: "text-right",
            orderable: false,
            searchable: false,
            responsivePriority: 7
          },
          {
            data: "amount",
            className: "text-right",
            footerClassName: "text-right",
            searchable: false,
            responsivePriority: 3
          },
          {
            data: "description",
            orderable: false,
            responsivePriority: 12
          }
        ],
        vueComponents: [
          {
            rootId: "commission-owner-modal-vue",
            component: JobCommisssionLink,
            options: {
              store
            }
          }
        ]
      }
    };
  },
  mounted() {
    this.$store.dispatch("addBreadcrumb", { label: "Commissions List" });
  }
};
</script>

<style lang="scss"></style>
